import { HttpErrorResponse } from '@angular/common/http';
import { ModuleErrorView, createModuleError } from './module-error.model';

export function mapHttpErrorToModuleError(
  err: unknown,
  fallbackMessage = 'Ocurrió un error inesperado.'
): ModuleErrorView {
  if (err instanceof HttpErrorResponse) {
    const body = err.error;
    let message = fallbackMessage;
    if (body && typeof body === 'object') {
      const record = body as Record<string, unknown>;
      if (typeof record.message === 'string' && record.message.trim()) {
        message = record.message;
      } else if (record.errors !== undefined && record.errors !== null) {
        message = String(record.errors);
      }
    } else if (typeof body === 'string' && body.trim()) {
      message = body;
    }
    return createModuleError(`HTTP_${err.status || 0}`, message, {
      httpStatus: err.status,
      recoverable: err.status >= 500 || err.status === 0,
    });
  }

  if (err instanceof Error && err.message) {
    return createModuleError('CLIENT_ERROR', err.message, { recoverable: true });
  }

  return createModuleError('UNKNOWN', fallbackMessage, { recoverable: true });
}
